import React from 'react'
import { Grid, Typography } from '@mui/material'
import PickUp from 'components/pickAndDrop/PickUp';
import meter from 'assets/images/meter.svg'
import car from 'assets/images/CarProfile.svg'
import rideTrackError from 'assets/images/tripErrorImg.svg'
import profile from "assets/images/ProfileVendor.svg";

function InvoiceMap(props) {
  const tripDetails = props?.tripDetails

  const handleImgError =(e) => {
    e.target.src = rideTrackError
  }

  const handleDriverImgError = (e) => {
    e.target.src = profile
  }
  return (
  
      <Grid container
        direction='column'
        justifyContent='center'
        alignItems='start'
      >

        <Grid container item
          direction='column'
          md={12} 
        >
          <Grid container item direction='row'
            justifyContent='space-between'
            alignItems='start'>
            <Grid item><Typography className='font24 fontMedium marginBottom25'>Trip Details</Typography></Grid>
            {props?.magicToken && <Grid item className="marginInline30 allotBody">
              <Typography className="font14 fontSemi flexend">{tripDetails?.companyName}</Typography> 
              <Typography className="font14 fontSemi">{'GST No- '+tripDetails?.gstNumber}</Typography> 
            </Grid>}
          </Grid>
          
          <Grid item container direction='row'
            justifyContent='space-between'
            alignItems='start'
            >
            <Grid item md={5} sm={12} className='mapAlign' >
              <img src={tripDetails?.tripRouteImage?.url? tripDetails?.tripRouteImage?.url : rideTrackError} onError={handleImgError} className="width100 height100" alt='mapImage' />
            </Grid>
            <Grid item
              direction='column' md={6} sm={12}
              justifyContent='space-evenly'
              alignItems='center'
            >
              <Grid item container direction='row'
                justifyContent='flex-start'
                alignItems='center'
                className='dashedBottomLine'
              >
                <Grid item >
                  <img src={tripDetails?.DriverProfile?.avtar?.url ? tripDetails?.DriverProfile?.avtar?.url : profile } alt='profile' onError={handleDriverImgError} className='profileImage' />
                </Grid>
                <Grid >
                  <Typography>{tripDetails?.driverName && tripDetails?.driverName != null ? tripDetails?.driverName : 'NA'}</Typography>
                </Grid>
              </Grid>
              <Grid item container direction='row'
                justifyContent='flex-start'
                alignItems='center'
                className='dashedBottomLine'>
                <Grid item >
                  <img className='marginRight10 iconImage' src={meter} alt='meter' />
                </Grid>
                <Grid>
                  <Typography>{tripDetails?.actualDistance+"KM "+ (tripDetails?.actualTravelTime*60).toFixed(0)+"MIN"}</Typography>
                </Grid>
              </Grid>
              <Grid item container direction='row'
                justifyContent='flex-start'
                alignItems='center'
                className='dashedBottomLine'>
                <Grid item>
                  <img className='marginRight10 iconImage' src={car} alt='car' />
                </Grid>
                <Grid >
                  <Typography>{(tripDetails?.carType && tripDetails?.carType !=null ? tripDetails?.carType : 'NA')+" - "+ (tripDetails?.carName && tripDetails?.carName !=null ? tripDetails?.carName : 'NA')}</Typography>
                </Grid>
              </Grid>
              <Grid item
                className='dashedLine'>
                <PickUp tableData={tripDetails} />
              </Grid>

            </Grid>
          </Grid>

        </Grid>
        <Grid container item
          direction='column'
          className='marginTop25' md={12}
        >
          <Typography className='font24 fontMedium '>Bill Details</Typography>
          <Grid container item
            direction='column'
            justifyContent='space-between'
            alignItems='center'
            className='billdetails' md={12}>
            <Grid item container
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              className='dashedBottomLine '>
              <Grid item>
                <Typography className='font18 fontNormal'>Description</Typography>
              </Grid>
              <Grid item>
                <Typography className='font18 fontNormal'>Amount</Typography>
              </Grid>
            </Grid>

            {tripDetails?.rideFee && tripDetails?.rideFee !== null && <Grid item container
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              className='marginbottom20'>
              <Grid item>
                <Typography className='font14'>Trip Fare</Typography>
              </Grid>
              <Grid item>
                <Typography className='font14'>{"₹"+tripDetails?.rideFee}</Typography>
              </Grid>
            </Grid>}
            {tripDetails?.tollFee && tripDetails?.tollFee !== null && <Grid item container
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              className='marginbottom20'>
              <Grid item>
                <Typography className='font14'>Toll/Parking/Waiting Fee</Typography>
              </Grid>
              <Grid item>
                <Typography className='font14'>{"₹"+tripDetails?.tollFee}</Typography>
              </Grid>
            </Grid>}

            {tripDetails?.cgst && tripDetails?.cgst !== null && <Grid item container
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              className='marginbottom20'>
              <Grid item>
                <Typography className='font14'>CGST </Typography>
                <Typography className='colorGrey font12'>{tripDetails?.cgst+"%"}</Typography>
              </Grid>
              <Grid item>
                <Typography className='font14'>{"₹"+tripDetails?.cgstAmount}</Typography>
              </Grid>
            </Grid>}
           {tripDetails?.sgst && tripDetails?.sgst !== null &&  <Grid item container
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              className=' dashedBottomLine marginbottom20'>
              <Grid item>
                <Typography className='font14'>SGST </Typography>
                <Typography className='colorGrey font12'>{tripDetails?.sgst+"%"}</Typography>
              </Grid>
              <Grid item>
                <Typography className='font14'>{"₹"+tripDetails?.sgstAmount}</Typography>
              </Grid>
            </Grid>}
            {tripDetails?.subTotal && tripDetails?.subTotal !== null && <Grid item container
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              className=' marginbottom20'>
              <Grid item>
                <Typography className='font14'> Subtotal</Typography>
              </Grid>
              <Grid item>
                <Typography className='font14'>{"₹"+tripDetails?.subTotal}</Typography>
              </Grid>
            </Grid>}
            {tripDetails?.discount && tripDetails?.discount !== null && <Grid item container
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              className=' solidBottomLine marginbottom20'>
              <Grid item>
                <Typography className='font14'>Discount </Typography>
                <Typography className='colorGrey font12'>{tripDetails?.discountPercentage} </Typography>
              </Grid>
              <Grid item>
                <Typography className='font14'>{"-₹"+tripDetails?.discount}</Typography>
              </Grid>
            </Grid>}
            {tripDetails?.totalAmount && tripDetails?.totalAmount !== null && <Grid item container
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              className=' marginbottom20'>
              <Grid item>
                <Typography className='font20 fontMedium'>Total </Typography>
                <Typography className='colorGrey font16'>Customer Trip Fare </Typography>
              </Grid>
              <Grid item>
                <Typography className='font20 fontMedium'>{"₹"+tripDetails?.totalAmount}</Typography>
              </Grid>
            </Grid>}
            {tripDetails?.refund && tripDetails?.refund !== null &&  <Grid item container
              direction='row'
              justifyContent='space-between'
              alignItems='center'
              className=' dashedBottomLine marginbottom20'>
              <Grid item>
                <Typography className='font14'>Refund</Typography>
              </Grid>
              <Grid item>
                <Typography className='font14'>{"₹"+tripDetails?.refund}</Typography>
              </Grid>
            </Grid>}
          </Grid>
        </Grid>

      </Grid>
  )
}

export default InvoiceMap